import uniqBy from 'lodash/uniqBy';

function carrierPrefix(shippingMethod: string) {
  if (shippingMethod.startsWith('ics')) {
    return shippingMethod.slice(0, 7); // first 7 chars identify merchant, e.g. "ics-clr" means Caliroots for "ics-clrg" method
  }
  return shippingMethod.split('-')[0];
}

export function uniqueCarriers(shippingMethods: string[]) {
  return uniqBy(shippingMethods, method => carrierPrefix(method));
}
